import React from 'react';
import { useReactToPrint } from 'react-to-print';
type Props = {
  customerContent: () => React.ReactInstance | null;
  staffContent: () => React.ReactInstance | null;
  ownerContent: () => React.ReactInstance | null;
};
const usePrintReceiptWithStaff = ({ customerContent, staffContent }: Props) => {

  const doPrintStaffReceipt = useReactToPrint({
    content: () => staffContent(),
  });

  const doPrint = useReactToPrint({
    content: () => customerContent(),
    onAfterPrint: () => doPrintStaffReceipt(),
  });


  return doPrint;
};

export default usePrintReceiptWithStaff;
